export function WorkOrderManualClaimService($http, $q, apexApiUrl) {
    'ngInject';
    const service = {
        retrieveWorkOrderMaualClaims: retrieveWorkOrderMaualClaims,
        retrieveWorkOrderMaualClaim: retrieveWorkOrderMaualClaim,
        createWorkOrderManualClaim: createWorkOrderManualClaim,
        updateWorkOrderManualClaim: updateWorkOrderManualClaim,
        patchWorkOrderManualClaim: patchWorkOrderManualClaim,
        deleteWorkOrderManualClaim: deleteWorkOrderManualClaim
    };

    return service;

    function retrieveWorkOrderMaualClaims(query) {
        return $http({
            method: "GET",
            url: apexApiUrl + "work-order-manual-claims",
            params: query,
            headers: {
                Accept: 'application/json'
            }
        }).then(function (response) {
            return response.data;
        })
    }

    function retrieveWorkOrderMaualClaim(workOrderClaimID) {
        return $http({
            method: "GET",
            url: apexApiUrl + "work-order-manual-claims/" + workOrderClaimID,
            headers: {
                Accept: "application/json"
            }
        }).then(function (response) {
            return response.data;
        });
    }

    function createWorkOrderManualClaim(workOrderManualClaim) {
        return $http({
            method: "POST",
            url: apexApiUrl + "work-order-manual-claims",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            data: workOrderManualClaim
        }).then(function (response) {
            return response.data;
        });
    }

    function updateWorkOrderManualClaim(workOrderClaimID, workOrderManualClaim) {
        return $http({
            method: "PUT",
            url: apexApiUrl + "work-order-manual-claims/" + workOrderClaimID,
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            data: workOrderManualClaim
        })
    }

    function patchWorkOrderManualClaim(workOrderClaimID, workOrderManualClaim) {
        return $http({
            method: "PATCH",
            url: apexApiUrl + "work-order-manual-claims/" + workOrderClaimID,
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            data: workOrderManualClaim
        })
    }

    function deleteWorkOrderManualClaim(workOrderClaimID) {
        return $http({
            method: "DELETE",
            url: apexApiUrl + "work-order-manual-claims/" + workOrderClaimID
        }).then(function (response) {
            return response.data;
        });
    }

}
